/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';

import {
  LayerGroup, LeafletEvent, Marker,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { IWeatherStatus } from '@/interfaces/IWeatherStatus';
import { IModalData } from '@/services/layers/IModalData';
import useWeatherDataParser from '@/components/composers/useWeatherDataParser';

export default class ParkingMetersLayerService extends LayerService {
  // eslint-disable-next-line global-require
  markerIcon = 'stacje-meteo.svg';

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const currentWeather: IWeatherStatus = metaData.last_status as IWeatherStatus;

    const { direction, directionToIconMapper } = useWeatherDataParser();

    const template: string = `
      <div class="weather-modal__description">
        ${!!metaData.description ? metaData.description : this.noData}
      </div>
      <div class="weather-modal__container">
        <div class="weather-modal__air-quality">
          <div class="weather-modal__text-data text-data">
            <div class="text-data__label">CO</div>
            <div class="text-data__value">
              ${!!currentWeather && currentWeather.airCO !== null ? currentWeather.airCO + ' µg/m³' : this.noData}
            </div>
          </div>
          <div class="weather-modal__text-data text-data">
            <div class="text-data__label">NO</div>
            <div class="text-data__value">
              ${!!currentWeather && currentWeather.airNO !== null ? currentWeather.airNO + ' µg/m³' : this.noData}
            </div>
          </div>
          <div class="weather-modal__text-data text-data">
            <div class="text-data__label">PM 2.5</div>
            <div class="text-data__value">
            ${!!currentWeather && currentWeather['airPM2.5'] !== null
              ? currentWeather['airPM2.5'] + ' µg/m³'
              : this.noData}
            </div>
          </div>
          <div class="weather-modal__text-data text-data">
            <div class="text-data__label">PM 10</div>
            <div class="text-data__value">
            ${!!currentWeather && currentWeather.airPM10 !== null
              ? currentWeather.airPM10 + ' µg/m³'
              : this.noData}
            </div>
          </div>
        </div>

        <div class="weather-modal__current-weather current-weather">
          <div class="current-weather__icon-row">
            <div v-if="false" class="current-weather__icon">
              <i class="icomoon-meteo-rain"></i>
            </div>
            <div class="current-weather__temperature">
            ${!!currentWeather && currentWeather.tempAir !== null
              ? currentWeather.tempAir + 'ºC'
              : this.noData}
            </div>
          </div>
          <div v-if="false" class="current-weather__description">
          ${!!currentWeather && currentWeather.surfState !== null
            ? currentWeather.surfState
            : this.noData}
          </div>
        </div>
        <div class="weather-modal__weather-details">
          <div class="weather-modal__icon-data icon-data">
            <div class="icon-data__icon">
              <i class="icomoon-meteo-humidity"></i>
            </div>
            <div class="icon-data__value">
            ${!!currentWeather && currentWeather.humidity !== null
              ? currentWeather.humidity + '% RH'
              : this.noData}
            </div>
          </div>
          <div class="weather-modal__icon-data icon-data">
            <div class="icon-data__icon">
              <i class="icomoon-meteo-pressure"></i>
            </div>
            <div class="icon-data__value">
            ${!!currentWeather && currentWeather.pressure !== null
              ? currentWeather.pressure + ' hPa'
              : this.noData}
            </div>
          </div>
          <div class="weather-modal__icon-data icon-data">
            <div class="icon-data__icon">
              <i class="icomoon-meteo-heavy-wind"></i>
            </div>
            <div class="icon-data__value">
            ${!!currentWeather && currentWeather.windSpeed !== null
              ? currentWeather.windSpeed + ' km/h'
              : this.noData}
            </div>
          </div>
          <div class="weather-modal__icon-data icon-data">
            <div class="icon-data__icon">
              <i class="${!!currentWeather && currentWeather.windDeg !== null
                          ? directionToIconMapper(direction(currentWeather.windDeg)) :
                          this.noData}">
              </i>
            </div>
            <div class="icon-data__value">
            ${!!currentWeather && currentWeather.windDeg !== null
              ? direction(currentWeather.windDeg)
              : ''}
            </div>
          </div>
        </div>
      </div>
    `;

    const lastUpdate = !!currentWeather && !!currentWeather.dateTime
                       ? currentWeather.dateTime as string
                       : this.noData;
    const title = !!metaData.deviceName ? metaData.deviceName : this.noData;
    const modalData: IModalData = {
      title: title,
      content: template,
      navigationPoint: undefined,
      lastUpdate: lastUpdate,
      icon: this.markerIcon,
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.weatherStations;
    return this.generatePruneClusterMarkerLayer(points);
  };

  protected generateHtmlPointTemplate = (metaData: any, leafletMarker: Marker<any>): string => {
    const template: string = `
        <div
            class="map-simple-icon map-simple-icon--parking-meter"
            style='background-image: url("${require('@/assets/img/map-icons/' + this.markerIcon)}")'
        ></div>
      `;

    return template;
  }
}
